/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';

/**
 * Action that shows the login modal.
 *
 * @return {Object}
 */
export const showLoginModal = () => ({
  type: SHOW_LOGIN_MODAL,
});

export const HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL';

/**
 * Action that shows the login modal.
 *
 * @return {Object}
 */
export const hideLoginModal = () => ({
  type: HIDE_LOGIN_MODAL,
});
